export const CONSTANT = {
  statusList: [
    // 状态
    { name: '启用', value: 'ENABLE' },
    // { name: '不确定', value: 'INDETERMINATE' },
    { name: '禁止', value: 'DISABLE' },
  ],
  fieldTypeList: [
    // 字段类型
    { value: null, label: '请选择' },
    { value: 'STRING', label: 'string' },
    { value: 'INTEGER', label: 'int' },
  ],
  operatorList: [
    // 运算符
    { value: null, label: '请选择' },
    { value: 'GTE', label: '大于等于' },
    { value: 'LTE', label: '小于等于' },
    { value: 'GT', label: '大于' },
    { value: 'LT', label: '小于' },
    { value: 'EQ', label: '等于' },
    { value: 'NEQ', label: '不等于' },
    { value: 'IN', label: '属于' },
    { value: 'CONTAINS', label: '包含' },
    { value: 'MATCH', label: '匹配' },
  ],
  operationTypeList: [
    { name: 'ADD', value: '新增' },
    { name: 'MODIFY', value: '修改' },
    { name: 'DELETE', value: '删除' },
  ],
  valueTypeList: [
    { value: 'CONSTANT', label: '常量' },
    { value: 'VARIABLE', label: '变量' },
  ],
};

export default CONSTANT;
